import { GET_CONTRACTOR_CATEGORIES_LIST } from 'fixtures/actions'
import { GET_CONTRACTOR_CATEGORIES } from 'fixtures/api'
import { getAllList } from 'services/cmsService'

const getAllContractorCategoriesData = () => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(GET_CONTRACTOR_CATEGORIES)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_CONTRACTOR_CATEGORIES_LIST,
      payload: data
    })
  }
}

export { getAllContractorCategoriesData }
